import { createSelector } from 'reselect';
import { AppState } from '$/store';
import * as Bixby from '$/core';

const getHasPublicCompaniesFeatureFlag = ({ releaseFeatureFlagsState, loginState }: AppState) => {
  return !!(
    releaseFeatureFlagsState &&
    loginState &&
    loginState.featureFlags &&
    loginState.featureFlags.includes(Bixby.Constants.CLIENT_PUBLIC_COMPANIES) &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagPublicCompanies && _.isEnabled
    )
  );
};

const getHasBixbyComplianceFeatureFlag = ({ releaseFeatureFlagsState, loginState }: AppState) => {
  return !!(
    releaseFeatureFlagsState &&
    loginState &&
    loginState.featureFlags &&
    loginState.featureFlags.includes(Bixby.Constants.CLIENT_BIXBY_COMPLIANCE) &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagBixbyCompliance && _.isEnabled
    )
  );
};

const getHasBixbyComplianceAutoApprovalFeatureFlag = ({ releaseFeatureFlagsState, loginState }: AppState) => {
  return !!(
    releaseFeatureFlagsState &&
    loginState &&
    loginState.featureFlags &&
    loginState.featureFlags.includes(Bixby.Constants.CLIENT_BIXBY_COMPLIANCE) &&
    loginState.featureFlags.includes(Bixby.Constants.CLIENT_BIXBY_COMPLIANCE_AUTO_APPROVAL) &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagBixbyCompliance && _.isEnabled
    )
  );
};

const getHasBixbyComplianceDemoModeFeatureFlag = ({ releaseFeatureFlagsState, loginState }: AppState) => {
  return !!(
    releaseFeatureFlagsState &&
    loginState &&
    loginState.featureFlags &&
    loginState.featureFlags.includes(Bixby.Constants.CLIENT_BIXBY_COMPLIANCE) &&
    loginState.featureFlags.includes(Bixby.Constants.CLIENT_BIXBY_COMPLIANCE_DEMO_MODE) &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagBixbyCompliance && _.isEnabled
    )
  );
};

const getHasUsEuroGroupingFeatureFlag = ({ loginState }: AppState) => {
  return !!(
    loginState &&
    loginState.featureFlags &&
    loginState.featureFlags.includes(Bixby.Constants.CLIENT_US_EURO_GROUPING)
  );
};

const getIsClientInPreviewFeatureFlag = ({ loginState }: AppState) => {
  return !!(
    loginState &&
    loginState.featureFlags &&
    loginState.featureFlags.includes(Bixby.Constants.CLIENT_IS_IN_PREVIEW)
  );
};

const getIsClientIsCutoverToCreditSightsFeatureFlag = ({ loginState }: AppState) => {
  return !!(
    loginState &&
    loginState.featureFlags &&
    loginState.featureFlags.includes(Bixby.Constants.CLIENT_IS_CUTOVER_TO_CREDITSIGHTS)
  );
};

export const getHasPublicCompaniesFeatureFlagState = createSelector(
  [getHasPublicCompaniesFeatureFlag],
  (hasPublicCompaniesFeatureFlag: boolean) => ({ hasPublicCompaniesFeatureFlag })
);

export const getHasBixbyComplianceFeatureFlagState = createSelector(
  [getHasBixbyComplianceFeatureFlag],
  (hasBixbyComplianceFeatureFlag: boolean) => ({ hasBixbyComplianceFeatureFlag })
);

export const getHasBixbyComplianceAutoApprovalFeatureFlagState = createSelector(
  [getHasBixbyComplianceAutoApprovalFeatureFlag],
  (hasBixbyComplianceAutoApprovalFeatureFlag: boolean) => ({ hasBixbyComplianceAutoApprovalFeatureFlag })
);

export const getHasBixbyComplianceDemoModeFeatureFlagState = createSelector(
  [getHasBixbyComplianceDemoModeFeatureFlag],
  (hasBixbyComplianceDemoModeFeatureFlag: boolean) => ({ hasBixbyComplianceDemoModeFeatureFlag })
);


export const getHasUsEuroGroupingFeatureFlagState = createSelector(
  [getHasUsEuroGroupingFeatureFlag],
  (hasUsEuroGroupingFeatureFlag: boolean) => ({ hasUsEuroGroupingFeatureFlag })
);

export const getIsClientInPreviewFeatureFlagState = createSelector(
  [getIsClientInPreviewFeatureFlag],
  (isInPreview: boolean) => ({ isInPreview })
);

export const getIsClientIsCutoverToCreditSightsFeatureFlagState = createSelector(
  [getIsClientIsCutoverToCreditSightsFeatureFlag],
  (isCutoverToCreditSights: boolean) => ({ isCutoverToCreditSights })
);